import React from "react";

import { findTarget, findRel } from "../../../shared/utils/stringUtilities";
import { formatImageAlt } from "../../../shared/utils/stringUtilities";

import "./cardNews.scss";

const CardNews = (props: CardNewsInterface) => {
  const { imgSrc, imgAlt, title, link, label, gtmMark, modeGallery } = props;

  return (
    <a
      className={`a-card-news${
        modeGallery ? " a-card-news-gallery" : ""
      } ${gtmMark}`}
      href={link}
      target={findTarget(link)}
      rel={findRel(link)}
    >
      <div className="a-card-news__img">
        <img src={imgSrc} alt={formatImageAlt(imgAlt)} className={`${gtmMark}`} />
      </div>
      <span className={`a-card-news__label ${gtmMark}`}>{label}</span>
      <div className={`a-card-news__title ${gtmMark}`}>{title}</div>
    </a>
  );
};

interface CardNewsInterface {
  imgSrc: string;
  imgAlt: string;
  title: any;
  link: string;
  label: string;
  gtmMark?: string;
  modeGallery?: boolean;
}

export default CardNews;
